import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@comicrelief/component-library';
import {
  UnstyledFieldset,
  UnstyledLegend,
  FieldsetSectionHeading,
  FieldsetFirstChild
} from './Fieldset.style';

const Fieldset = React.forwardRef((
  {
    legend = '',
    description = '',
    children,
    ...otherProps
  }, ref
) => {
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  const restChildren = childrenArray.slice(1);

  return (
    <UnstyledFieldset {...otherProps} ref={ref}>
      <div>
        {legend && (
          <UnstyledLegend>
            <FieldsetSectionHeading tag="h3">{legend}</FieldsetSectionHeading>
          </UnstyledLegend>
        )}
        {description && <Text tag="p" size="s">{description}</Text>}
      </div>

      {firstChild && (
        <FieldsetFirstChild>
          {firstChild}
        </FieldsetFirstChild>
      )}

      {restChildren && (
        <div>
          {restChildren}
        </div>
      )}
    </UnstyledFieldset>
  );
});

Fieldset.propTypes = {
  legend: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired
};

export default Fieldset;
